/**
 * Contextual sub-element editing session store.
 *
 * BIM's "Modify Sub Elements" workflow: a sketch tool (add point / add split
 * line / sub-element pick) records which surface element is being shape-edited
 * and which of its shape points is currently selected. The OptionsBar binds a
 * numeric offset editor to that selected point. This keeps the coupling between
 * the viewport tool and the OptionsBar out of props drilling.
 */
import { create } from 'zustand';

export interface SubElementSession {
    /** element being shape-edited */
    elementId: string | null;
    /** active tool mode inside the session */
    mode: 'select' | 'addPoint' | 'addSplitLine' | null;
    /** index into geometryData.shapeEditor.points of the selected point */
    selectedPointIndex: number | null;
}

interface SubElementState extends SubElementSession {
    setSession: (session: Partial<SubElementSession>) => void;
    clear: () => void;
}

export const useSubElementStore = create<SubElementState>((set) => ({
    elementId: null,
    mode: null,
    selectedPointIndex: null,
    setSession: (partial) => set(partial),
    clear: () => set({ elementId: null, mode: null, selectedPointIndex: null }),
}));
